import React, { useRef } from 'react';
import { GridColumn, Grid } from '@progress/kendo-react-grid';
import TitleComponent from '~/src/components/common/forms/Title/TitleComponent';
import { withState } from '~/src/components/common/grid/WrappedGrid';
import { API_URL } from '~/src/utils/constants';
import WhitePad from '~/src/components/common/WhitePad/WhitePad';
import { Link, useHistory } from 'react-router-dom';
import { DateCell, LocationCell } from '~/src/components/common/grid/Cells';
import GridWrapper from '~/src/components/common/GridWrapper';
import styled from 'styled-components';

export default function MissingInventoryList(): JSX.Element {
  const stateRef = useRef(null);
  const url = `${API_URL}/inventory/get-missing-for-warehouse/4d13e3a6-40fc-43de-852d-8485281f89bc`;
  const StatefullGrid = withState(Grid, url);
  const history = useHistory();

  const productNameCell = (row: any): JSX.Element => {
    const { dataItem } = row;

    return (
      <td>
        <Link to={`/inventory/list-for-generic/${dataItem.product.genericProductId}`}>
          {dataItem.product.genericProduct.name}
        </Link>
      </td>
    );
  };

  return (
    <WhitePad isFluid>
      <TitleComponent title="Missing Inventory" 
      onLeftHandler={(): void => history.push('/inventory')} 
      titleLeft="Back"
       />
      <TableWrapper>
        <GridWrapper>
          <StatefullGrid ref={stateRef}>
            <GridColumn field="name" title="Product Name" cell={productNameCell} />
            <GridColumn field="fullDuUnits" title=" Boxes" />
            <GridColumn field="singleDpUnits" title=" Displays" />
            <GridColumn field="singleCuUnits" title="Single Units" />
            <GridColumn field="sellOrder.orderNumber" title="Order" />
            <GridColumn field="customer.name" title="Customer" />
            <GridColumn field="transactionDateTime" title="Lost Date" cell={DateCell} />
            <GridColumn field="warehouseLocation" title="Last Location" cell={LocationCell} />

            {/* 
        <GridColumn field="gtin" title="Barcode" cell={BarcodeCell} />
        <GridColumn field="totalCuUnits" title="Total Units" />
      <GridColumn field="expirationDate" title="Expiration Date" filterCell={DateRangeFilterCell} /> */}
          </StatefullGrid>
        </GridWrapper>
      </TableWrapper>
    </WhitePad>
  );
}

const TableWrapper = styled.div`
  div {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;
